var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaniLogoLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1632,
    height: 201,
    viewBox: "0 0 1632 201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-986 608)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "VANI_MEETINGS",
    "data-name": "VANI MEETINGS",
    transform: "translate(1263 -457)",
    fill: "#1a1d1e",
    fontSize: 144,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.15em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VANI MEETINGS")), /*#__PURE__*/React.createElement("g", {
    id: "meeting",
    transform: "translate(986.001 -611.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 18.211,
    cy: 18.211,
    r: 18.211,
    transform: "translate(85.288 6.375)",
    fill: "#2061e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M139.488,33.7a5.8,5.8,0,0,0-8.1,2.776A30.291,30.291,0,0,1,75.67,36.6a5.816,5.816,0,0,0-8.1-2.935A24.3,24.3,0,0,0,54.938,54.937V79.218a12.141,12.141,0,0,0,24.281,0V72.879a5.8,5.8,0,0,1,5.8-5.8h36.958a5.8,5.8,0,0,1,5.8,5.8v6.339a12.141,12.141,0,0,0,24.281,0V54.937A24.306,24.306,0,0,0,139.488,33.7Z",
    fill: "#2160fd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M197.587,153.483a18.21,18.21,0,1,0-18.211,31.541h0a18.686,18.686,0,0,0,25.281-6.665C209.686,169.649,206.3,158.512,197.587,153.483Z",
    fill: "#2061e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M34.29,161.4a18.209,18.209,0,0,0-24.875-6.665h0C.7,159.762-2.686,170.9,2.344,179.61a18.686,18.686,0,0,0,25.281,6.665A18.211,18.211,0,0,0,34.29,161.4Z",
    fill: "#2061e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M94.557,168.663a12.156,12.156,0,0,0-16.584-4.444l-5.583,3.223a5.694,5.694,0,0,1-7.778-2.084l-18.587-32.2a5.693,5.693,0,0,1,2.085-7.778l5.581-3.221a12.141,12.141,0,0,0-11.929-21.149c-.071.039-.141.08-.211.121L20.524,113.272a24.3,24.3,0,0,0-12.1,21.759,5.664,5.664,0,0,0,6.448,5.372,30.293,30.293,0,0,1,27.9,48.287,5.709,5.709,0,0,0,1.476,8.322,24.3,24.3,0,0,0,24.841.369l21.032-12.137A12.156,12.156,0,0,0,94.557,168.663Z",
    fill: "#2160fd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1343-2",
    "data-name": "Group 1343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1342-2",
    "data-name": "Group 1342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145-2",
    "data-name": "Path 145",
    d: "M147.37,104.695a12.156,12.156,0,0,0,5.088,16.4l5.705,3a5.694,5.694,0,0,1,2.386,7.691l-17.315,32.9a5.694,5.694,0,0,1-7.692,2.386l-5.7-3a12.141,12.141,0,1,0-11.525,21.373c.072.038.143.076.216.113l21.483,11.31a24.3,24.3,0,0,0,24.858-1.375,5.665,5.665,0,0,0,1.1-8.32,30.292,30.292,0,0,1,25.96-49.354,5.709,5.709,0,0,0,6.251-5.688,24.3,24.3,0,0,0-12.94-21.208L163.763,99.6A12.156,12.156,0,0,0,147.37,104.695Z",
    fill: "#2160fd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaniLogoLong);
export default __webpack_public_path__ + "static/media/vani_logo_long.18f7a07c17147ebe31039fa1a1392be3.svg";
export { ForwardRef as ReactComponent };